module.exports = __webpack_public_path__ + "img/744.08dcdf82.jpg";